import React from "react";
import { Box, Text, VStack, Button, keyframes } from "@chakra-ui/react";

const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

/**
 * DemoActionCard — floating card at bottom-center for "do this" action prompts.
 * No backdrop overlay — product stays fully visible and interactive underneath.
 *
 * Used for: PLAY_ACTIVITY, VIEW_RESULTS, REPORT_CTA
 */
const DemoActionCard = ({ isOpen, stepConfig, onAction, onEndDemo }) => {
  if (!isOpen || !stepConfig || stepConfig.modalType !== "action_card")
    return null;

  return (
    <Box
      position="fixed"
      bottom="24px"
      left="50%"
      transform="translateX(-50%)"
      w="calc(100% - 32px)"
      maxW="340px"
      zIndex={1300}
      bg="white"
      borderRadius="16px"
      boxShadow="xl"
      p={5}
      fontFamily="Geist, sans-serif"
      animation={`${fadeInUp} 0.4s ease-out`}
    >
      <VStack spacing={3} align="center" textAlign="center">
        {stepConfig.heading && (
          <Text fontSize="md" fontWeight="700" color="#0C001C">
            {stepConfig.heading}
          </Text>
        )}

        {stepConfig.body && (
          <Text fontSize="xs" color="#6B7280" lineHeight="1.6">
            {stepConfig.body}
          </Text>
        )}

        {stepConfig.buttons?.length > 0 && (
          <VStack spacing={2} w="100%" pt={1}>
            {stepConfig.buttons.map((btn) => (
              <Button
                key={btn.action}
                w="100%"
                bg={btn.variant === "primary" ? "#4C47CC" : "transparent"}
                color={btn.variant === "primary" ? "white" : "#6B7280"}
                fontWeight="700"
                fontSize="sm"
                borderRadius="8px"
                py={5}
                border={btn.variant === "secondary" ? "1px solid" : "none"}
                borderColor={
                  btn.variant === "secondary" ? "gray.300" : "transparent"
                }
                _hover={{
                  bg: btn.variant === "primary" ? "#3A37B3" : "#F3F4F6",
                }}
                onClick={() => onAction(btn.action)}
              >
                {btn.label}
              </Button>
            ))}
          </VStack>
        )}

        <Text
          fontSize="xs"
          color="gray.400"
          cursor="pointer"
          _hover={{ color: "gray.600" }}
          onClick={onEndDemo}
          pt={0.5}
        >
          End Demo
        </Text>
      </VStack>
    </Box>
  );
};

export default DemoActionCard;
